import { render, staticRenderFns } from "./minirefresh.vue?vue&type=template&id=0fd7807b"
import script from "./minirefresh.vue?vue&type=script&lang=js"
export * from "./minirefresh.vue?vue&type=script&lang=js"
import style0 from "./minirefresh.vue?vue&type=style&index=0&id=0fd7807b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports